/**
 * Leaderboard.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import { Card } from '@minerva-analytics/pantheon';

import LeaderboardTable from '../../components/LeaderboardTable';
import LoginForm from '../../components/LoginForm';
import CardHeader from '../../components/CardHeader';
import CardBody from '../../components/CardBody';

import userActions from '../../store/user/actions';
import authedUser from '../../store/user/selectors/authedUser';
import selectedLeaderboardRaw from '../../store/leaderboard/selectors/selectedLeaderboard';
import selectLeaderboardRaw from '../../store/leaderboard/actions/selectLeaderboard';
import getLeaderboardRaw from '../../store/leaderboard/actions/getLeaderboard';

import {
  LeaderboardContainer,
  LeaderboardTitle,
} from './Leaderboard.styles';
import Loadable from '../../components/Loadable';


/**
 * View for the leaderboard
 *
 */
export class Leaderboard extends Component {
  static propTypes = {
    leaderboard: PropTypes.array,
    getLeaderboard: PropTypes.func.isRequired,
    selectLeaderboard: PropTypes.func.isRequired,
    selectedLeaderboard: PropTypes.string,
    facebookLogin: PropTypes.func.isRequired,
    gmailLogin: PropTypes.func.isRequired,
    user: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const {
      selectLeaderboard,
      getLeaderboard,
    } = this.props;

    selectLeaderboard(`top100`);
    getLeaderboard(`top100`);
  }

  renderBody = () => {
    const {
      leaderboard,
      selectedLeaderboard,
      facebookLogin,
      gmailLogin,
    } = this.props;

    return (
      <>
        <LoginForm
          facebookLogin={ () => facebookLogin(`leaderboard`) }
          gmailLogin={ () => gmailLogin(`leaderboard`) }
          headlineText="Sign Up To Start Receiving Trivia Questions!"
        />
        <LeaderboardTitle>Top 100 users</LeaderboardTitle>
        <LeaderboardTable
          linkToUsers={ selectedLeaderboard === `friends` }
          data={ leaderboard }
        />
      </>
    );
  }

  render() {
    const {
      leaderboard,
      user,
    } = this.props;

    if (user) {
      return <Redirect to={`/profile/${user.id}/stats`} />;
    }

    return (
      <LeaderboardContainer>
        <Helmet>
          <title>QuizHive Leaderboard</title>
        </Helmet>
        <Card size="medium">
          <CardHeader>
            Trivia Leaderboard
          </CardHeader>
          <CardBody>
            <Loadable ready={!!leaderboard} renderFunc={() => (this.renderBody())} />
          </CardBody>
        </Card>
      </LeaderboardContainer>
    );
  }
}

export default connect((state) => {
  return {
    leaderboard: selectedLeaderboardRaw(state),
    selectedLeaderboard: state.leaderboard.selected,
    user: authedUser(state),
  };
}, {
  selectLeaderboard: selectLeaderboardRaw,
  getLeaderboard: getLeaderboardRaw,
  facebookLogin: userActions.facebookLogin,
  gmailLogin: userActions.gmailLogin,
})(Leaderboard);
